const SET_APPLICATIONS = 'SET_APPLICATIONS';
const SET_HISTORICAL_APPLICATIONS = 'SET_HISTORICAL_APPLICATIONS';
const GET_APPLICATIONS_ERROR = 'GET_APPLICATIONS_ERROR';
const GET_HISTORICAL_APPLICATIONS_ERROR = 'GET_HISTORICAL_APPLICATIONS_ERROR';

export const APPLICATIONS_ACTION_TYPES = {
    SET_APPLICATIONS,
    SET_HISTORICAL_APPLICATIONS,
    GET_APPLICATIONS_ERROR,
    GET_HISTORICAL_APPLICATIONS_ERROR
};